import { isWebView } from 'Utils/webView';

export const useIsWebView = () => isWebView();
